import { Trans } from '@lingui/macro'
import { EgretLoadable } from 'egret'
import { authRoles } from '../../auth/authRoles'
import CreateSurvey from './CreateSurvey'

const SurveyTab = EgretLoadable({
  loader: () => import('./SurveyTab')
})

const SurveyScore = EgretLoadable({
  loader: () => import('./SurveyScore')
})

const SurveyTemplateList = EgretLoadable({
  loader: () => import('./SurveyTemplates')
})

const AvaliableSurveys = EgretLoadable({
  loader: () => import('./AvaliableSurveys')
})
const ESATSurveys = EgretLoadable({
  loader: () => import('./ESATSurveys')
})
const SurveyScoreCards = EgretLoadable({
  loader: () => import('./SurveyScoreCards')
})

const ScoreCardCreator = EgretLoadable({
  loader: () => import('./ScoreCardCreator')
})
const FormPage = EgretLoadable({
  loader: () => import('../forms/editor/FormWizard')
})

const surveyRoutes = [
  {
    path: '/surveys/sampleSurvey',
    component: SurveyTab,
    auth: authRoles.admin
  },
  {
    path: '/surveys/ScoreCards',
    component: SurveyScoreCards,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SCORE_CARDS_LABEL</Trans>
  },
  {
    path: '/surveys/ScoreCardCreator/:templateId/:scoreCardId',
    component: ScoreCardCreator,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SCORE_CARDS_EDITOR_LABEL</Trans>
  },
  {
    path: '/surveys/SurveyTemplates',
    component: SurveyTemplateList,
    auth: authRoles.editor,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SURVEY_SCORE_LABEL</Trans>
  },
  {
    path: '/surveys/SelfAssessmentSurveys',
    component: AvaliableSurveys,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SELF_ASSESSMENT_TOOL_LABEL</Trans>
  },
  {
    path: '/surveys/ESAT',
    component: ESATSurveys,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_ENVIRONMENTAL_SELF_ASSESSMENT_TOOL_LABEL</Trans>
  },
  {
    path: '/surveys/SurveyTab/:id/:surveyId/:mode',
    component: SurveyTab,
    auth: authRoles.grantee,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: '/surveys/SurveyScore/:id/:templateId?/:scoreCardId?',
    component: SurveyScore,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SURVEY_SCORE_LABEL</Trans>
  },
  {
    path: '/surveys/CreateSurvey/:id/:templateType',
    component: CreateSurvey,
    auth: authRoles.editor,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SURVEY_TEMPLATE_EDITOR_LABEL</Trans>
  },
  {
    path: '/surveys/CreateSurvey',
    component: CreateSurvey,
    auth: authRoles.editor,
    exact: true
  },
  {
    path: '/surveys/FormPage/:id?',
    component: FormPage
  }
]

export default surveyRoutes
